import { connect } from 'react-redux';

import ChatbotWidget from './component';

const mapStateToProps = ({ global: { lan }, hotel: { hotel } }) => ({
	lan,
	hotel,
});

export default connect(mapStateToProps)(ChatbotWidget);



// WEBPACK FOOTER //
// ./src/components/molecules/ChatbotWidget/index.js